import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { productSlug } from '@/utils/slugify';

const KEY = 'cs_recently_viewed';
const MAX = 6;

export function trackProductView(product) {
  try {
    const raw = localStorage.getItem(KEY);
    let list = raw ? JSON.parse(raw) : [];
    list = list.filter(p => p.id !== product.id);
    list.unshift({ id: product.id, name: product.name, image_url: product.image_url, price: product.price, brand: product.brand });
    if (list.length > MAX) list = list.slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {}
}

export default function RecentlyViewed({ currentProductId }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      const list = raw ? JSON.parse(raw) : [];
      setProducts(list.filter(p => p.id !== currentProductId));
    } catch {}
  }, [currentProductId]);

  if (products.length === 0) return null;

  return (
    <div className="mt-12 pt-8 border-t border-gray-100">
      <h2 className="font-display font-bold text-xl text-gray-900 mb-5">RÉCEMMENT CONSULTÉS</h2>
      <div className="flex gap-3 overflow-x-auto pb-2">
        {products.map(p => (
          <Link key={p.id} to={`/product/${productSlug(p)}`}
            className="shrink-0 w-36 group border border-gray-200 rounded-lg overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 bg-white">
            <div className="aspect-square bg-gray-50 overflow-hidden">
              <img src={p.image_url} alt={p.name}
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500 p-2" />
            </div>
            <div className="p-2">
              {p.brand && <p className="text-[10px] font-bold text-cs-blue uppercase tracking-wide">{p.brand}</p>}
              <p className="text-xs font-medium text-gray-700 line-clamp-2 leading-tight mt-0.5">{p.name}</p>
              <p className="text-sm font-bold text-gray-900 mt-1">{p.price?.toFixed(2)} €</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}